export default __webpack_public_path__ + "img/olivertree_gameroom-01.61661c3305b3c43cd999c046492ceb96.png";